export default __webpack_public_path__ + "static/media/pressonopennetwork.218e43b6.png";